(function () {
  if (window.ucCartTrustRemoveLoaded) return;
  window.ucCartTrustRemoveLoaded = true;

  function addFooterSpacingStyle() {
    if (document.getElementById('uc-cart-trust-remove-style')) return;

    var style = document.createElement('style');
    style.id = 'uc-cart-trust-remove-style';
    style.textContent = '#halo-cart-sidebar.uc-cart-redo .uc-cart-footer{padding-bottom:8px!important;}#halo-cart-sidebar.uc-cart-redo .uc-cart-continue{margin-bottom:0!important;}';
    document.head.appendChild(style);
  }

  function removeTrustRows() {
    document.querySelectorAll('#halo-cart-sidebar .uc-cart-trust').forEach(function (row) {
      row.remove();
    });
  }

  function cleanup() {
    addFooterSpacingStyle();
    removeTrustRows();
  }

  document.addEventListener('uc:cart:updated', cleanup);
  document.addEventListener('cart-update', cleanup);
  document.addEventListener('DOMContentLoaded', function () {
    cleanup();

    var wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (wrapper && window.MutationObserver) {
      new MutationObserver(cleanup).observe(wrapper, { childList: true, subtree: true });
    }
  });
})();
